import * as React from "react";
import { Form } from "semantic-ui-react";
import { validate } from "not-valid";

import { Input } from "@neworbit/simpleui-input";

import { QuestionProps, AnsweredQuestion } from "../../model";
import { isQuestionDisabled, CustomQuestionConfig } from "../../questionnaireConfig/models";

import { QuestionWrapper } from "./QuestionWrapper";

type AllProps = QuestionProps;

const TimeQuestion: React.FunctionComponent<QuestionProps> = (props: AllProps) => {

    const getValidatedQuestion = async (question: string, answer: string): Promise<AnsweredQuestion> => {
        const errors = await validate(props.validators || [], answer);
        const isValid = errors.length === 0 && (!!answer?.trim() || !props.mandatory);
        return { question, answer, isValid };
    };

    const validateAndUpdateQuestion = (answer: string): void => {
        if (isQuestionDisabled(props.questionConfig)) {
            return null;
        }

        const questionText = (props.questionConfig as CustomQuestionConfig).questionText;
        const newQuestion: AnsweredQuestion = { question: questionText, answer };
        if (!(props.validators && props.validators.length)) {
            newQuestion.isValid = !props.mandatory || !!answer?.trim();
        }
        props.updateQuestion(newQuestion);
        if (props.onAnswerChange) {
            props.onAnswerChange(newQuestion.answer);
        }
        if (props.validators && props.validators.length) {
            props.validateQuestion(getValidatedQuestion(props.questionConfig.questionText, answer));
        }
    };

    const onChange = (answer: string) => {
        validateAndUpdateQuestion(answer);
    };

    const renderValue = (): React.ReactNode => {
        if (props.readonly) {
            return <div>{props.answer}</div>;
        }
        return (
            <Input.Time
                value={props.answer as string}
                onChange={onChange}
                readOnly={props.readonly}
                required={props.mandatory}
            />
        );
    };

    if (isQuestionDisabled(props.questionConfig)) {
        return null;
    }

    return (
        <QuestionWrapper
            inline={props.inline}
            question={props.questionConfig.questionText}
            mandatory={props.mandatory}
            hideDivider={props.hideDivider}
            error={props.showError && (props.mandatory && !props.answer && "This field must be completed")}
            readonly={props.readonly}
            removable={{
                ...props.removable,
                questionId: props.questionConfig.id,
                isRemovedByUser: props.isRemovedByUser
            }}
            outdated={{
                ...props.outdated,
                questionId: props.questionConfig.id
            }}
        >
            <Form.Field>
                {renderValue()}
            </Form.Field>
        </QuestionWrapper>
    );
};

export { TimeQuestion };
